<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <!-- <v-col cols="12" md="12">
                <label>Column per view</label>
                <v-text-field v-model.number="fields.colPerView" type="number" min="1" :hide-details="true" />
              </v-col> -->
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.containerPage.background"
                          @change="event => (fields.containerPage.background = event.target.value)"
                        />
                        <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Card Title</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['show-card-title']"
              label="Show card title"
              :hide-details="true"
              class="mb-2 mt-0"
            />
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Category Items</label>
            <v-btn small color="primary" @click="handleAddCategory">Add Category</v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.categories" :key="`category-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>{{ item.title || `Category ${index + 1}` }}</span>
                  <v-btn small icon @click.stop="handleRemoveCategory(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, index)"
                  :image="{ imageSrc: item.image }"
                  :height="`220`"
                  :typeUpload="'image'"
                  @callbackDelete="() => handleRemoveUpload(index)"
                />
                <div class="mb-3 mt-3">
                  <label>Title</label>
                  <v-text-field v-model="item.title" :hide-details="true" />
                </div>
                <div class="mb-3">
                  <label>Link</label>
                  <v-text-field v-model="item.link" :hide-details="true" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

const defaultCategory = () => ({
  title: 'Minimizer Bra',
  image:
    'https://www.hsialife.com/cdn/shop/files/hsia-minimizer-bra-category-icon.jpg?crop=region&crop_height=150&crop_left=0&crop_top=7&crop_width=150&v=1778124142&width=150',
  link: '#',
});

const defaultFields = () => ({
  title: 'Card Hsia Category Section',
  'card-title': '',
  'show-card-title': true,
  styleSection: {
    topPadding: true,
    bottomPadding: true,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  colPerView: 8,
  categories: [defaultCategory()],
});

export default {
  name: 'CardHsiaCategory',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: defaultFields(),
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
    };
  },
  mounted() {
    const fallback = defaultFields();
    const extracted = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...fallback,
      ...extracted,
      styleSection: {
        ...fallback.styleSection,
        ...(extracted.styleSection || {}),
      },
      containerPage: {
        ...fallback.containerPage,
        ...(extracted.containerPage || {}),
      },
      categories:
        Array.isArray(extracted.categories) && extracted.categories.length ? extracted.categories : fallback.categories,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        colPerView: Number(this.fields.colPerView) > 0 ? Number(this.fields.colPerView) : 1,
        categories: (this.fields.categories || []).filter(Boolean).map(item => ({
          title: item.title || '',
          image: item.image || '',
          link: item.link || '#',
        })),
      };

      if (!payload.categories.length) {
        payload.categories = [defaultCategory()];
      }

      const updateHtml = updateHtmlFromData.sectionCardHsiaCategory(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddCategory() {
      this.fields.categories.push(defaultCategory());
    },
    handleRemoveCategory(index) {
      if (this.fields.categories.length <= 1) return;
      this.fields.categories.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields.categories[index].image = obj.imageSrc || '';
    },
    handleRemoveUpload(index) {
      this.fields.categories[index].image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
</style>
